import { twMerge } from "tailwind-merge";
import { MessageCircle } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";
import { CountBadge } from "@themes/pollinator/ui/CountBadge";

export type Props = {
  children?: React.ReactNode;
  variant?: "primary" | "secondary" | "ghost" | "link-inline";
  title?: string;
  unreadCount?: number;
  className?: string;
  containerClassName?: string;
  onClick?: () => void;
};

export function ChatButton({
  variant = "ghost",
  title = "Open Circle Chat",
  unreadCount = 0,
  children,
  className,
  containerClassName,
  onClick,
}: Props) {
  return (
    <div className={twMerge("relative flex items-center", containerClassName)}>
      <Button
        variant={variant}
        iconComponent={MessageCircle}
        onClick={onClick}
        title={title}
        className={className}
      >
        {children}
      </Button>
      <CountBadge count={unreadCount} />
    </div>
  );
}

export default ChatButton;


